module.exports = __webpack_public_path__ + "static/img/luxiangjilu2.d882857.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/luxiangjilu2.png
// module id = GK/W
// module chunks = 24